var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage"},[_c('StageHeader',{attrs:{"title":"Planning authority decision","status":_vm.planningAuthorityStatus,"data":_vm.planningAuthorityData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }